// extracted by mini-css-extract-plugin
module.exports = {"overflow":"overflow--CdKQn","detailsHead":"detailsHead--EZPft","detailsHeadName":"detailsHeadName--1ZylD","tabs":"tabs--UdAPZ"};